var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wallet"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0.625H18C19.1046 0.625 20 1.67433 20 2.96875V17.0313C20 18.3257 19.1046 19.375 18 19.375H2C0.89543 19.375 0 18.3257 0 17.0313V2.96875C0 1.67433 0.89543 0.625 2 0.625ZM16.6016 8.125H3.39844C2.55707 8.125 1.875 8.85953 1.875 9.76562V10.3125H6.53244C6.8018 10.3125 7.06013 10.4277 7.25059 10.6329L8.26622 11.7266C8.72605 12.2218 9.34971 12.5 10 12.5C10.6503 12.5 11.274 12.2218 11.7338 11.7266L12.7494 10.6329C12.9399 10.4277 13.1982 10.3125 13.4676 10.3125H18.125V9.76562C18.125 8.85953 17.4429 8.125 16.6016 8.125ZM1.875 5.625C1.875 4.58947 2.55707 3.75 3.39844 3.75H16.6016C17.4429 3.75 18.125 4.58947 18.125 5.625V6.25H1.875V5.625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.a4024e555c5a403051b7f5d1e245590a.svg";
export { ForwardRef as ReactComponent };